// extracted by mini-css-extract-plugin
module.exports = {"review":"Review_review__10PgV","user":"Review_user__N1DSx","pf_image":"Review_pf_image__p6YjQ","content":"Review_content__2aaW5"};